import axios from "axios";

// สร้าง Axios instance สำหรับเรียก Node.js API
// const axiosNode = axios.create({
//   baseURL: process.env.VUE_APP_APIURL_NODE || "http://localhost:3000",
//   timeout: 10000,
//   headers: {
//     "Content-Type": "application/json",
//     // สามารถเพิ่ม headers อื่นๆ ที่จำเป็นได้ที่นี่
//   },
// });

let config = {
  baseURL: process.env.VUE_APP_APIURL_NODE || "https://service.jm2.ac.th/",
  timeout: 1000000,
  // headers:
  //   process.env.NODE_ENV == "development"
  //     ? {
  //         "Content-Type": "text/plain",
  //       }
  //     : {
  //         "Content-Type": "text/plain",
  //         Authorization: `Bearer a3a0b4a03d76b65522fa24c56c873fe2`,
  //       },
};

const axiosNode = axios.create(config);

// Request interceptor
axiosNode.interceptors.request.use(
  (config) => {
    // สามารถเพิ่ม token หรือ headers เฉพาะสำหรับ Node.js API ที่นี่
    // เช่น config.headers.Authorization = 'Bearer ' + getToken()
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
axiosNode.interceptors.response.use(
  (response) => {
    // สามารถปรับแต่ง response ก่อนส่งไปใช้งาน
    return response;
  },
  (error) => {
    // จัดการ error ที่มาจาก Node.js API
    return Promise.reject(error);
  }
);

export default axiosNode;
